/* WTF — capture Reddit match keys onto the cart so they reach the order.
 *
 * WHY: Reddit's Conversions API needs `uuid` (or `external_id`) on BOTH the
 * Pixel and CAPI events, otherwise its session-based deduplication cannot pair
 * them and every server-sent purchase double-counts one the Pixel already
 * recorded. We cannot set the Pixel's conversion_id -- it belongs to the
 * Shopify "Reddit Ads" app and runs in a sandboxed Web Worker -- so uuid is the
 * only dedup key available to us. `rdt_cid` is Reddit's click ID and is the
 * single strongest attribution signal their docs list.
 *
 * Cart attributes persist onto the order, which is how these values reach the
 * server. Same mechanism as the personalization line-item properties.
 *
 * Fails silently by design: nothing here may break a storefront page.
 */
(function () {
  'use strict';

  var ATTR_UUID = '_rdt_uuid';
  var ATTR_CID = '_rdt_cid';
  var STORE_CID = 'wtf_rdt_cid'; // localStorage: the click ID must outlive the landing page
  var SENT_KEY = 'wtf_rdt_sent'; // sessionStorage: what we already wrote, to avoid re-posting

  function cookie(name) {
    try {
      var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
      return m ? decodeURIComponent(m.pop()) : '';
    } catch (e) {
      return '';
    }
  }

  function clickId() {
    // Reddit appends rdt_cid to the landing URL. Persist it: the visitor will
    // navigate several times before checkout and the param is long gone by then.
    try {
      var fromUrl = new URLSearchParams(window.location.search).get('rdt_cid');
      if (fromUrl) {
        localStorage.setItem(STORE_CID, fromUrl);
        return fromUrl;
      }
      return localStorage.getItem(STORE_CID) || '';
    } catch (e) {
      return '';
    }
  }

  function run() {
    var uuid = cookie('_rdt_uuid');
    var cid = clickId();
    if (!uuid && !cid) return; // nothing worth a request

    var payload = {};
    if (uuid) payload[ATTR_UUID] = uuid;
    if (cid) payload[ATTR_CID] = cid;

    // One write per session per distinct value. Without this guard every page
    // view posts to /cart/update.js for no benefit.
    var fingerprint = JSON.stringify(payload);
    try {
      if (sessionStorage.getItem(SENT_KEY) === fingerprint) return;
    } catch (e) {
      /* private mode: fall through and just write once per page */
    }

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/update.js'
            : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: payload })
    })
      .then(function () {
        try { sessionStorage.setItem(SENT_KEY, fingerprint); } catch (e) {}
      })
      .catch(function () { /* never surface a tracking failure to a shopper */ });
  }

  // The Reddit pixel sets _rdt_uuid asynchronously; on a cold first visit the
  // cookie often is not there yet at DOMContentLoaded. Re-check a couple of
  // times rather than losing the very first session, which is the ad click.
  function schedule() {
    run();
    setTimeout(run, 1500);
    setTimeout(run, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
